import * as Website from '../Config/Website.js';

const ClickToggleClass = () => {
  const targetElms = document.getElementsByClassName('js-toggleClass');
  
  for(const targetElm of targetElms) {
    targetElm.addEventListener('click', () => {
      targetElm.classList.toggle(Website.classList.act);
    });
  }
}

export default ClickToggleClass;